<template>
<div>
    <div id="topo" v-for="(config, index) in configs" :key="index">
        <router-link class="navbar-brand logo" :to="{name: 'home'}">
            <img src="@/assets/images/logo.png" alt="" width="150px" />
        </router-link>
        
         <a class="btn-portal" target="_blank" href="https://ava.univitoriaead.com.br"><span><i class="fa fa-user"></i> SOU ALUNO</span></a>
        <a class="btn-portal" target="_blank" href="https://universa.univitoriaead.com.br/matricula/acadgeral-aluno/captacao"><span><i class="fa fa-arrow-up"></i> MATRICULE-SE</span></a>
        <a class="btn-portal" target="_blank" href="https://universa.univitoriaead.com.br/financeiro/painel/titulos"><span><i class="fa fa-file"></i> 2 VIA DO BOLETO</span></a>
        <a v-if="config.facebook" target="_blank" class="btn-redes" :href="config.facebook"><span><i class="fa fa-facebook"></i></span></a>
        <a v-if="config.instagram" target="_blank" class="btn-redes" :href="config.instagram"><span><i class="fa fa-instagram"></i></span></a>
    </div>
    <!-- Start header -->
    <header class="top-navbar">
        <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <div class="container top">
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbars-host" aria-controls="navbars-rs-food" aria-expanded="false" aria-label="Toggle navigation">
            <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbars-host" v-for="(config, index) in configs" :key="index">
            <ul class="navbar-nav">
                <li class="nav-item">
                    <router-link class="nav-link" :to="{name: 'home'}">Início</router-link>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link" :to="{name: 'institucional'}">Institucional</router-link>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link" :to="{name: 'cursos'}">Pós Graduação</router-link>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link" :to="{name: 'contato'}">Contato</router-link>
                </li>
            </ul>
            <a v-if="config.celular" :href="'https://api.whatsapp.com/send?phone='+config.celular" target="_blank">
                <img class="whatsapp-top" src="https://images.tcdn.com.br/static_inst/integracao/imagens/whatsapp.png">
            </a>
            </div>
        </div>
        </nav>
    </header>
    <!-- End header -->
</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
    mounted() {
        this.getConfigs()
            .catch(response => this.$vToastify.error('Falha ao carregar configurações', 'Erro'))
    },

    computed: {
        ...mapState({
            configs: state => state.configs.items
        })
    },

    methods: {
        ...mapActions([
            'getConfigs',
        ])
    },
}
</script>